var map = {
	"./auto-import/auto-import.plugin": 2412,
	"./go-to-definition/go-to-definition.plugin": 846,
	"./go-to-error/go-to-error.plugin": 5815,
	"./macros/macros.plugin": 5563,
	"./path-completion/path-completion.plugin": 8379,
	"./prettier/prettier.plugin": 2581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8107;